import { ApiError } from "./utils";

const getCsrfToken = async (): Promise<string> => {
  const { token } = await fetch("/csrf", { credentials: "include" }).then((r) =>
    r.json()
  );
  return token;
};

export const adminAuthApi = {
  signIn: async (email: string, password: string): Promise<void> => {
    const token = await getCsrfToken();
    const response = await fetch("/admin/api/session", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": token,
      },
      credentials: "include",
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      const data = await response.json();
      throw new ApiError([data.error || "Invalid email or password"]);
    }
  },

  signOut: async (): Promise<void> => {
    const token = await getCsrfToken();
    await fetch("/admin/api/session", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": token,
      },
      credentials: "include",
    });
  },

  // The admin API doesn't expose a /me endpoint. To probe whether the
  // current session is authenticated as an admin we make a HEAD request
  // against any admin-scoped endpoint and treat a 2xx as signed in and a
  // 401 as signed out.
  isSignedIn: async (): Promise<boolean> => {
    const response = await fetch("/admin/api/v1/workspaces", {
      method: "HEAD",
      headers: { Accept: "application/json" },
      credentials: "include",
    });
    return response.ok;
  },
};
